module.exports = __webpack_public_path__ + "static/media/waterpark2.8f363d86.jpg";